import { type SessionContext } from 'server/src/context/context.type';
import { type Namespace as NamespaceType, type Socket as SocketType } from 'socket.io';

export namespace Admin {
    export const NAMESPACE = '/admin';

    export const HANDLING_TTL_MS = 60 * 60 * 1000;
    export const EXPIRY_PROMPT_GRACE_MS = 10 * 60 * 1000;

    export interface LeadHandlingChangedEvent {
        leadId: string;
        organizationId: string;
        handlingManagerId: string | null;
        handlingManagerName: string | null;
        handlingSince: string | null;
    }

    export interface LeadHandlingExpiringEvent {
        leadId: string;
        phoneNumber: string;
        handlingSince: string;
    }

    export interface HandlingChangedEvent {
        opportunityId: string;
        organizationId: string;
        handlingManagerId: string | null;
        handlingManagerName: string | null;
        handlingSince: string | null;
    }

    export interface HandlingExpiringEvent {
        opportunityId: string;
        title: string;
        handlingSince: string;
    }

    export interface CallCenterAlertEvent {
        alertId: string;
        type: "DISTRESS" | "EARLY_LEAVE" | "CALL_COORDINATOR";
        volunteerName: string;
        stationNumber: number | null;
        opportunityTitle: string | null;
        opportunityId: string | null;
        shiftId: string;
        volunteerId: string;
        reason: string | null;
    }

    export interface CallCenterMatchEvent {
        shiftId: string;
        volunteerId: string;
        matchesCount: number;
        dailyGoal: number;
        encouragement: string;
    }

    export interface CallCenterChatEvent {
        volunteerId: string;
        messageId: string;
        kind: "TEXT" | "DETAILS_CARD" | "INCOMING_CALL" | "SYSTEM";
        body: string;
        payload: Record<string, unknown> | null;
        createdAt: string;
        fromCoordinator: boolean;
    }

    export interface ServerEvents {
        'opportunity:handling-changed': (data: HandlingChangedEvent) => void;
        'opportunity:handling-expiring': (data: HandlingExpiringEvent) => void;
        'lead:handling-changed': (data: LeadHandlingChangedEvent) => void;
        'lead:handling-expiring': (data: LeadHandlingExpiringEvent) => void;
        'call-center:alert': (data: CallCenterAlertEvent) => void;
        'call-center:match': (data: CallCenterMatchEvent) => void;
        'call-center:chat': (data: CallCenterChatEvent) => void;
    }

    export interface ClientEvents {
        'org:join': (data: { organizationId: string }) => void;
    }

    export interface InterServerEvents {
        ping: () => void;
    }

    export interface Data {
        user: SessionContext;
    }

    export type Namespace = NamespaceType<
        ClientEvents,
        ServerEvents,
        InterServerEvents,
        Data
    >;

    export type Socket = SocketType<
        ClientEvents,
        ServerEvents,
        InterServerEvents,
        Data
    >;
}
